import { InferType, object, string } from 'yup';

import { AbstractRoute, CommonSearchParams, UseParamsReturn } from '@/core/lib/router/route';

class ContributionRoute extends AbstractRoute {
  static path = '/contribution/contribuer';

  getPath() {
    return ContributionRoute.path;
  }

  static isPrivate = false;

  static useParams(): UseParamsReturn {
    const { common } = AbstractRoute.useCommonParams();
    return { page: {}, search: {}, common };
  }

  static init(url: URL): ContributionRoute {
    const common = this.searchParamsToCommon(url.searchParams);
    return new ContributionRoute(common);
  }

  isPrivate() {
    return ContributionRoute.isPrivate;
  }

  resolve() {
    return `${this.getPath()}${this.computeParams()}`;
  }

  clone(common: CommonSearchParams = {}): ContributionRoute {
    const clone = ContributionRoute.init(new URL(`http://doesnotmatter.com${this.resolve()}`));
    clone.updateCommon(prev => ({ ...prev, ...common }));
    return clone;
  }
}

class StripeCreateCheckoutSessionRoute extends AbstractRoute {
  static path = '';

  getPath() {
    return StripeCreateCheckoutSessionRoute.path;
  }

  private href: string;

  static isPrivate = false;

  public isExternal = true;

  constructor(notificationPushPath: string) {
    super();

    this.href = notificationPushPath;
  }

  isPrivate() {
    return StripeCreateCheckoutSessionRoute.isPrivate;
  }

  resolve() {
    return this.href;
  }

  clone(): StripeCreateCheckoutSessionRoute {
    return this;
  }
}

const contributionSuccessRouteParamsSchema = object({
  session_id: string(),
});

export type ContributionSuccessRouteParamsSchema = InferType<typeof contributionSuccessRouteParamsSchema>;

class ContributionSuccessRoute extends AbstractRoute {
  static path = '/contribution/contribution-reussi';
  private params: ContributionSuccessRouteParamsSchema;

  constructor(contributionSuccessParams: ContributionSuccessRouteParamsSchema, common?: CommonSearchParams) {
    super(common);

    const inferredContributionSuccessRouteParams = contributionSuccessRouteParamsSchema.cast(contributionSuccessParams, { stripUnknown: true, assert: false });
    this.params = inferredContributionSuccessRouteParams;
  }

  getPath() {
    return ContributionSuccessRoute.path;
  }

  static isPrivate = false;

  static init(url: URL): ContributionSuccessRoute {
    const common = this.searchParamsToCommon(url.searchParams);
    const all = Array.from(url.searchParams.entries()).reduce((acc, [key, val]) => ({ ...acc, [key]: val }), {} as CommonSearchParams);

    const search = contributionSuccessRouteParamsSchema.cast(all, { stripUnknown: true, assert: true });

    return new ContributionSuccessRoute(search, common);
  }

  isPrivate() {
    return ContributionSuccessRoute.isPrivate;
  }

  resolve() {
    return `${this.getPath()}${this.computeParams(this.params)}`;
  }

  clone(common: CommonSearchParams = {}): ContributionSuccessRoute {
    const clone = ContributionSuccessRoute.init(new URL(`http://doesnotmatter.com${this.resolve()}`));
    clone.updateCommon(prev => ({ ...prev, ...common }));
    return clone;
  }
}

export default { ContributionRoute, StripeCreateCheckoutSessionRoute, ContributionSuccessRoute };
